import React from 'react';
import { useIntl } from 'umi';
import { digitalRevenueList } from '@/pages/intelligence/pages/TopCharts/_config/metricOptions';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useMarketFilterApi, {
  MarketSpecailType,
} from '@/pages/intelligence/hooks/useMarketSelector';
import {
  commonPCConsoleDefaultFilterValue,
  handleDetailPCUFilterParamsToApi,
} from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import PCUPhysicalDigital from '../index';
// import { getDeviceConfig, } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/utils';
import {
  getDetailPageCfg,
  DETAIL_PAGEID,
} from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/_config';
import {
  statsPCUTrend,
  statsPCUMarketTable,
  statsPCUMarketTrend,
} from '@/pages/intelligence/services/topcharts';

export default function DigitalRevenue(props: any) {
  const { entityType, gameId, pageId, tabType, gsdDevicesFlatten, gsdSegments } = props;
  const { formatMessage } = useIntl(); // 中英切换方法

  const { filterLoading, regionOptions } = useMarketFilterApi({
    filterType: MarketSpecailType.digitalRevenue,
  });

  const defaultFilterValue = {
    ...commonPCConsoleDefaultFilterValue,
  };
  const filterCfg = {
    filterKeyList: [filterKeyMap.RANGE_TIME],
    regionFilterParams: {},
    defaultValue: defaultFilterValue,
    resetFilterValue: {
      ...defaultFilterValue,
    },
    specialParams: {
      regionOptions, // 国家筛选器options,
      defalutMarket: ['global'], // 没取到交集用的默认值
      disableNoChina: true,
      rangeTimeType: FilterTimeType.commonRange,
      // disableIegg: false,
      // disableAnnie: true,
      isShowAlloftime: false,
      entityType,
    },
    showConfirmButton: false,
    haveFilterSaveBtn: false,
    handleFilterToApiParams: handleDetailPCUFilterParamsToApi,
  };

  // const deviceDefVales = getDeviceConfig(pageId, entityType)?.value;
  const pageCfg = getDetailPageCfg(pageId, tabType, entityType);
  const defaultByDeviceVal = pageCfg?.defaultByDeviceVal || undefined;
  const params = {
    source: 'source_steam',
    tab_name: 'pcu',
    regions: ['global'],
    segment: '',
    sort_field: 'source_steam__pcu',
    unified_id: gameId,
    entity_type: entityType,
    region_type: 'market',
    start_date: '',
    end_date: '',
    date_type: 'monthly',
    sort_type: 'desc',
    // device: hasDevice ? deviceDefVales : undefined,
    b_group_by_device: defaultByDeviceVal,
    // Countries/PCU 表格需要同时拿到 VGI + Alinea + Gamalytic 的 PCU/ACU/Followers/Reviews
    metric: [
      'pcu',
      'acu',
      'steamfollowers',
      'steamreviews',
      'alinea__pcu',
      'alinea__acu',
      'alinea__steamfollowers',
      'alinea__steamreviews',
      'gamalytic__pcu',
      'gamalytic__acu',
      'gamalytic__steamfollowers',
      'gamalytic__steamreviews',
      'source_steam__pcu',
      'source_steam__acu',
    ],
  };

  return (
    <PCUPhysicalDigital
      {...props}
      // entityType={'console'}
      // pageId={pageId}
      // pageLogInfo={dbiPageLogMes.topChartsConsoleGamesDigitalRevenue}
      tableCloumsList={digitalRevenueList}
      // hasRegionFilter={true}
      cardMetricName={formatMessage({ id: 'dbi_digital_revenue' })}
      filterCfg={filterCfg}
      filterLoading={filterLoading}
      // rangeTimeComponentDefault={latestTimeTypeHasData}
      filterIcon={
        <span className="dbi-statsfilter-warp-left-text">
          {formatMessage({ id: 'dbi_steam_only' })}
        </span>
      }
      pageCfg={pageCfg}
      pageParameters={params}
      metricKey={DETAIL_PAGEID.gamalytic__pcu}
      gsdDevicesFlatten={gsdDevicesFlatten}
      gsdSegments={gsdSegments}
      getTrendsFun={statsPCUTrend}
      getMarketTrendsFun={statsPCUMarketTrend}
      getMarketTableFun={statsPCUMarketTable}
    />
  );
}
